export type PortalHost = "patient" | "provider" | "admin";

type PortalEnv = {
  VITE_DEFAULT_BASE_URL?: string;
  VITE_PROVIDER_BASE_URL?: string;
  VITE_ADMIN_BASE_URL?: string;
};

export function normalizeHost(value?: string) {
  if (!value) return "";
  const trimmed = value.trim().toLowerCase();
  if (!trimmed) return "";

  let host = trimmed;
  if (host.includes("://")) {
    try {
      host = new URL(host).hostname.toLowerCase();
    } catch {}
  }

  host = host.split("/")[0] ?? host;
  host = host.replace(/:\d+$/, "");
  host = host.replace(/^\.+|\.+$/g, "");
  return host;
}

export function getConfiguredPortalHosts(env: PortalEnv) {
  return {
    patient: new Set([normalizeHost(env.VITE_DEFAULT_BASE_URL)].filter(Boolean)),
    provider: new Set([normalizeHost(env.VITE_PROVIDER_BASE_URL)].filter(Boolean)),
    admin: new Set([normalizeHost(getPortalBaseUrl(env, "admin"))].filter(Boolean)),
  };
}

export function getPortalBaseUrl(env: PortalEnv, portal: PortalHost) {
  if (portal === "provider") return env.VITE_PROVIDER_BASE_URL;
  if (portal === "admin") return env.VITE_ADMIN_BASE_URL;
  return env.VITE_DEFAULT_BASE_URL;
}

export function getAllowedViteHosts(env: PortalEnv) {
  const allowedHosts = new Set<string>(["localhost", "127.0.0.1"]);
  const configuredHosts = getConfiguredPortalHosts(env);

  for (const portal of Object.keys(configuredHosts) as PortalHost[]) {
    for (const host of configuredHosts[portal]) {
      allowedHosts.add(host);
    }

    const baseUrlHost = normalizeHost(getPortalBaseUrl(env, portal));
    if (baseUrlHost) {
      allowedHosts.add(baseUrlHost);
    }
  }

  return Array.from(allowedHosts);
}
